import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useTranslator } from '@jutro/locale';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { useDataRefresh } from '@xengage/gw-portals-viewmodel-react';

import messages from './MLHVQDiscrepancyPropertyGroupComponent.messages';
import metadata from './MLHVQDiscrepancyPropertyGroupComponent.metadata.json5';
import styles from './MLHVQDiscrepancyPropertyGroupComponent.module.scss';

function MLHVQDiscrepancyPropertyGroupComponent(props) {
    const {
        discrepancyProperties, showPropertyGroupDoubleBorderStyle
    } = props;
    const translator = useTranslator();
    const { refreshData } = useDataRefresh();

    const helpTextMap = {
        false: translator(messages.consumerReportHelpText)
    };

    const generateOverrides = () => {
        const overrides = discrepancyProperties.map((discrepancyPropertyVM, index) => {
            const constructAvailableValues  = () => {
                return [
                    {
                        "code": "true",
                        "name": (
                            <>
                                {discrepancyPropertyVM.hvqValue && discrepancyPropertyVM.hvqValue.value}
                                &nbsp;
                                <strong>{translator(messages.youEntered)}</strong>
                            </>
                        )
                    },
                    {
                        "code": "false",
                        "name": (
                            <>
                                {discrepancyPropertyVM.quoteValue && discrepancyPropertyVM.quoteValue.value}
                                &nbsp;
                                <strong>{translator(messages.consumerReportsShow)}</strong>
                            </>
                        )
                    }
                ]
            };

            return {
                [`discrepancyPropertyRadioBtn${index}`]: {
                    label: _.get(discrepancyPropertyVM, 'title.value'),
                    availableValues: constructAvailableValues(),
                    value: _.get(discrepancyPropertyVM, 'keepHvqValue.value'),
                    onValueChange: (value) => {
                        _.set(discrepancyPropertyVM, 'keepHvqValue.value', value);
                        refreshData();
                    },
                    showHelpText: index === 0,
                    helpTextTitleMap: index === 0 ? {} : undefined,
                    helpTextMap: index === 0 ? helpTextMap : undefined,
                }
            };
        });

        return Object.assign({}, ...overrides);
    };

    const overrideProps = {
        discrepancyProperty: {
            data: discrepancyProperties
        },
        mlHVQDiscrepancyPropertyGroupContainer: {
            className: showPropertyGroupDoubleBorderStyle ? 'ml-section double-border' : ''
        },
        ...generateOverrides()
    }

    const resolvers = {
        resolveClassNameMap: styles
    }

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            {...resolvers} />
    );
}

MLHVQDiscrepancyPropertyGroupComponent.propTypes = {
    discrepancyProperties: PropTypes.array,
    showPropertyGroupDoubleBorderStyle: PropTypes.bool
}

MLHVQDiscrepancyPropertyGroupComponent.defaultProps = {
    discrepancyProperties: [],
    showPropertyGroupDoubleBorderStyle: true
}

export default MLHVQDiscrepancyPropertyGroupComponent;